import React, { useState, useEffect, useRef } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Search } from "@material-ui/icons";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { ClasificadorProc } from "./modalClasificadorProc";
import CartasAgentes from "../agentes/cartasAgentes";
import { Toasts } from "../toasts";

const TablaClaseProc = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accclaseproducc = JSON.parse(localStorage.getItem("accclaseproducc"));

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          CÓDIGO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "descripcion",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          DESCRIPCIÓN
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "codigoclase",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code-branch">
          {" "}
          CÓDIGO CLASE
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-cogs">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [clase, setClase] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const txtBuscador = useRef();
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idclaseproduccion.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.codigoclaseproduccion
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "claseproduccion";
    let orden = "idclaseproduccion";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          txtBuscador.current.focus();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarRegistro = (id) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/produccion/verproduccion/${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idclaseproduccion > 0) {
            setClase(response.data);
            setMostrar2(true);
          } else {
            setMostrar2(true);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const gestionarExpendedor = (op, id) => (e) => {
    if (op === 4) {
      if (accclaseproducc.substring(0, 1) !== "0") {
        setOperacion(4);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accclaseproducc.substring(1, 2) !== "0") {
        setOperacion(op);
        setMostrar2(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accclaseproducc.substring(2, 3) !== "0") {
        setOperacion(op);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accclaseproducc.substring(3, 4) !== "0") {
        setOperacion(op);
        SeleccionarRegistro(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  return (
    <div className="p-0" style={{ height: "100%", width: "100%", margin: 0 }}>
      {/* <div className='h-2 p-5 title-table'>Clasificadores de Producción</div> */}
      <div className="row col-md-12" style={{ margin: 0 }}>
        <div className="col-md-12" style={{ margin: 0 }}>
          <div className="row col-md-12 py-5 d-flex justify-content-between">
            <input
              type="text"
              className=" col-2 form-control form-control-sm rounded-pill"
              ref={txtBuscador}
              onChange={handleSearch}
              placeholder="Buscar"
            />
            <div className="col-3 d-flex justify-content-end">
              <button
                onClick={gestionarExpendedor(1, "")}
                className={
                  accclaseproducc.substring(1, 2) === "0"
                    ? "btn btn-sm btn-secondary rounded-circle"
                    : "btn btn-sm btn-primary rounded-circle"
                }
              >
                <i className="fas fa-plus"></i>{" "}
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow key={index} style={{ padding: "0" }}>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.idclaseproduccion}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.descripcion}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {item.codigoclaseproduccion}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      <button
                        onClick={gestionarExpendedor(4, item.idclaseproduccion)}
                        className={
                          accclaseproducc.substring(0, 1) === "0"
                            ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                            : "btn btn-sm  btn-info rounded-circle ml-2"
                        }
                      >
                        <i className="fas fa-eye"></i>{" "}
                      </button>
                      <button
                        onClick={gestionarExpendedor(2, item.idclaseproduccion)}
                        className={
                          accclaseproducc.substring(2, 3) === "0"
                            ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                            : "btn btn-sm  btn-warning rounded-circle ml-2"
                        }
                      >
                        <i className="fa fa-edit"></i>{" "}
                      </button>
                      <button
                        onClick={gestionarExpendedor(3, item.idclaseproduccion)}
                        className={
                          accclaseproducc.substring(3, 4) === "0"
                            ? "btn btn-sm  btn-secondary rounded-circle ml-2"
                            : "btn btn-sm  btn-danger rounded-circle ml-2"
                        }
                      >
                        <i className="fa fa-trash"></i>{" "}
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>

        <ClasificadorProc
          show={mostrar2}
          operacion={operacion}
          clase={clase}
          onHideCancela={handleCancela2}
          onHideRenderizar={SeleccionarRegistros}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
      </div>
      <Dimmer active={activate} />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
};
export default TablaClaseProc;



// WEBPACK FOOTER //
// ./src/components/impuestoprodu/tablaClaseProc.js